import React, {useState } from 'react'
import { useHotkeys } from 'react-hotkeys-hook'

import { sprintRouter } from './SlideDeckRouter'
import { tutorialRouter } from './Tutorials'

//import { se_slidedeckTTh } from './SL44000'

import { getSlideDecksFromClassSection } from '../DataAndAPIs/ClassSections'

export const createSlideInfo = (classSectionID, sprint, session, slideNumber) => {
	const sprintInt = parseInt(sprint)
	const sessionInt = parseInt(session)
	const slideNumberInt = parseInt(slideNumber)

	const slideInfo = {
		id: classSectionID,
		sprint: sprintInt,
		session: sessionInt,
		slideNumber: slideNumberInt
	}
	return slideInfo
}

export const RenderTutorialSlide = (tutorialID, slideNumber, pathPrefixAndID) => {
	const slideDeck = tutorialRouter(tutorialID)
	return RenderSlideFromSlidedeck(slideDeck, slideNumber, pathPrefixAndID)

	/*
	// Define footer and navigation functions.
	const incrementSlide = () => { 
		let newSlideNumber = slideNumber
		if (slideNumber < slideDeck.length) {
			newSlideNumber = slideNumber + 1
		}
		window.location.assign('/slide-tutorial/'+tutorialID+'/'+newSlideNumber)
	}
	useHotkeys('right, down, pagedown', () => { incrementSlide() })

	const decrementSlide = () => { 
		let newSlideNumber = slideNumber
		if (slideNumber > 1) {
			newSlideNumber = slideNumber - 1
		}
		window.location.assign('/slide-tutorial/'+tutorialID+'/'+newSlideNumber)
	}
	useHotkeys('left, up, pageup', () => { decrementSlide() })

	const renderFooter = () => {
		return ( <div>
			<p style={{flex:1, position:"absolute", right:80, bottom:20}}><span onClick={()=>decrementSlide()}>&larr; </span>
			{slideNumber} of {slideDeck.length}<span onClick={()=>incrementSlide()}> &rarr;</span></p>
		</div> )
	}

	const slideDeck = tutorialRouter(tutorialID)
	const slide = slideDeck[slideNumber-1]
	return ( <div>
		{slide()}
		{renderFooter()}
	</div> )
	*/
}

const RenderSlideFromSlidedeck = (slideDeck, slideNumber, pathPrefixAndID) => {
	// Define footer and navigation functions.
	const incrementSlide = () => { 
		let newSlideNumber = slideNumber
		if (slideNumber < slideDeck.length) {
			newSlideNumber = slideNumber + 1
		}
		window.location.assign(pathPrefixAndID+newSlideNumber)
	}
	useHotkeys('right, down, pagedown', () => { incrementSlide() })

	const decrementSlide = () => { 
		let newSlideNumber = slideNumber
		if (slideNumber > 1) {
			newSlideNumber = slideNumber - 1
		}
		window.location.assign(pathPrefixAndID+newSlideNumber)
	}
	useHotkeys('left, up, pageup', () => { decrementSlide() })

	const renderFooter = () => {
		return ( <div>
			<p style={{flex:1, position:"absolute", right:80, bottom:20}}><span onClick={()=>decrementSlide()}>&larr; </span>
			{slideNumber} of {slideDeck.length}<span onClick={()=>incrementSlide()}> &rarr;</span></p>
		</div> )
	}

	const slide = slideDeck[slideNumber-1]
	return ( <div>
		{slide()}
		{renderFooter()}
	</div> )
}

export const RenderSlide = (slideInfo) => {
	const getSlideDeck = (slideInfo) => {
		const classSectionSlideDecks = getSlideDecksFromClassSection()
		return classSectionSlideDecks[slideInfo.sprint-1][slideInfo.session-1]()
	}

	const getRenderSlide = (slideInfo) => {
		const slideDeck = getSlideDeck(slideInfo)
		return slideDeck[slideInfo.slideNumber-1]
	}

	const getDeckLength = (slideInfo) => {
		const slideDeck = getSlideDeck(slideInfo)
		return slideDeck.length
	}

	const renderSlide = getRenderSlide(slideInfo)
	const deckLength = getDeckLength(slideInfo)

	// Define footer and navigation functions.
	const incrementSlide = () => { 
		let newSlideNumber = slideInfo.slideNumber
		if (slideInfo.slideNumber < deckLength) {
			newSlideNumber = slideInfo.slideNumber + 1
		}
		window.location.assign('/slide/'+slideInfo.id+'/'+slideInfo.sprint+'/'+slideInfo.session+'/'+newSlideNumber)
	}
	useHotkeys('right, down, pagedown', () => { incrementSlide() })

	const decrementSlide = () => { 
		console.log('decrementSlide()') 
		let newSlideNumber = slideInfo.slideNumber
		if (slideInfo.slideNumber > 1) {
			newSlideNumber = slideInfo.slideNumber - 1
		}
		window.location.assign('/slide/'+slideInfo.id+'/'+slideInfo.sprint+'/'+slideInfo.session+'/'+newSlideNumber)
	}
	useHotkeys('left, up, pageup', () => { decrementSlide() })

	const renderFooter = () => {
		return ( <div>
			<p style={{flex:1, position:"absolute", right:80, bottom:20}}><span onClick={()=>decrementSlide()}>&larr; </span>
			{slideInfo.slideNumber} of {deckLength}<span onClick={()=>incrementSlide()}> &rarr;</span></p>
		</div> )
	}

	return ( <div>
		{renderSlide()}
		{renderFooter()}
	</div> )
}

// The RenderDeck function is depreciated. All new slide should be displayed using RenderSlide.
export function RenderDeck(classSectionID, sprint, session, totalSessionsInSprint) {
	const classSectionIDToClassNumber = (classSectionID) => {
		const parts = classSectionID.split('-');
		return parts[2];
	}

	const classNumber = classSectionIDToClassNumber(classSectionID)
	const deck = sprintRouter(classNumber + '-' + sprint + '-' + session)

	const [count, setCount ] = useState(0) 
	const incrementSlide = () => { setCount(prevCount => prevCount + 1) }
	useHotkeys('right, down, pagedown', () => { incrementSlide() })

	const decrementSlide = () => { setCount(prevCount => prevCount - 1) }
	useHotkeys('left, up, pageup', () => { decrementSlide() })

	const displaySlide = (index) => {
		if (index < 0) { 
			setCount(0)
			return deck[0]()
		} else if (index >= deck.length) { 
			setCount(deck.length-1) 
			return deck[deck.length-1]()
		} else {
			return deck[index]()
		}
	}

	const displayFooter = () => {
		return ( <div>
			<p style={{flex:1, position:"absolute", right:80, bottom:20}}><span onClick={()=>decrementSlide()}>&larr; </span>
			{count+1} of {deck.length}<span onClick={()=>incrementSlide()}> &rarr;</span></p>
		</div> )
	}

	return ( <div>
		{displaySlide(count)}
		{displayFooter()}
	</div> )
  }

